export const moduleSlug = "OBJECT_STRUCTURES";

export const VALIDATORS_TYPE = {
    object: "object",
    objectProperties: "objectProperties"
};

export default { moduleSlug };